import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
// import Hero from '../components/hero'

const ITPage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'IT | ' + data.siteTitle.siteMetadata.title}
        meta={[
          { name: 'description', content: 'IT overriding description but not keywords.' }
        ]}
      />
      <div style={{margin: '90px auto', maxWidth: '92%'}}>
        <h1>IT</h1>
        <p>Welcome to the it page.</p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default ITPage
